const normalizeText = (text: string | null | undefined): string | null => {
  if (!text) {
    return '';
  }

  return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_');
};

export default normalizeText;
